import React, { useState } from "react";
import axios from "axios";
import "../styles/Signup.css";
import ills from "../image/illustrate.png";
import logo from "../image/logoname.png";
import illsMobile from "../image/illustration.png";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "./Loader";
import { ensureValidToken, setTokens } from "../utils/authService";
import "../styles/ResetPassword.css"; 

const Signup = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [formData, setFormData] = useState({
      old_password: "",
      new_password: "",
      confirm_password: "",
    });
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState(null);
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({
        ...formData,
        [name]: value,
      });
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      
      if (formData.new_password !== formData.confirm_password) {
        setError("New password and confirm password don't match");
        return;
      }
  
      setIsLoading(true);
      setError(null);
      setSuccessMessage(null);
  
      try {
        // Get valid token (from location.state or from cookies)
        let accessToken = location.state?.accessToken;
        if (!accessToken) {
          accessToken = await ensureValidToken();
          if (!accessToken) {
            setError("Authentication required. Please log in again.");
            navigate("/login");
            return;
          }
        }

        const response = await axios.post(
          "https://api.nexcard.co.in/api/profile/password/reset/",
          formData,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            }
          }
        );

        setSuccessMessage("Password reset successfully! Redirecting...");
        
        // Store the new tokens in cookies if provided in response
        if (response.data.access && response.data.refresh) {
          setTokens(response.data.access, response.data.refresh);
        }
  
          navigate("/home-web-holder");
      } catch (error) {
        console.error("Password reset error:", error);
        
        if (error.response) {
          const backendError = error.response.data;
          
          if (backendError.detail) {
            setError(backendError.detail);
          } else if (backendError.old_password) {
            setError(`Old password: ${backendError.old_password.join(' ')}`);
          } else if (backendError.new_password) {
            setError(`New password: ${backendError.new_password.join(' ')}`);
          } else if (backendError.confirm_password) {
            setError(`Confirm password: ${backendError.confirm_password.join(' ')}`);
          } else if (backendError.non_field_errors) {
            setError(backendError.non_field_errors.join(' '));
          } else {
            setError("Password reset failed. Please try again.");
          }
        } else if (error.request) {
          setError("Network error. Please check your internet connection.");
        } else {
          setError("An unexpected error occurred. Please try again.");
        }
      } finally {
        setIsLoading(false);
      }
    };

  return (
    <div className="signup-container">
      <div className="signup-left">
        <div className="logoup">
          <img src={logo} alt="NexCard Logo" />
        </div>
        <div className="mobile-illustration">
          <img src={illsMobile} alt="Mobile Illustration" />
        </div>
        <h2 style={{marginBottom:"15px"}}>Reset Your Password</h2>
      
      <form className="login-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Temporary Password</label>
          <input
            type="password"
            name="old_password"
            placeholder="Enter your temporary password"
            value={formData.old_password}
            onChange={handleChange}
            required
          />
        </div>
        
        <div className="form-group">
          <label>New Password</label>
          <input
            type="password"
            name="new_password"
            placeholder="Enter your new password"
            value={formData.new_password}
            onChange={handleChange}
            required
          />
        </div>
        
        <div className="form-group">
          <label>Confirm New Password</label>
          <input
            type="password"
            name="confirm_password"
            placeholder="Confirm your new password"
            value={formData.confirm_password}
            onChange={handleChange}
            required
          />
        </div>
        
        {error && <div className="error-message">{error}</div>}
        {successMessage && <div className="success-message">{successMessage}</div>}
        
        <button 
          type="submit" 
          className="reset-password-btn"
          disabled={isLoading}
        >
          {isLoading ? <Loader /> : "Reset Password"}
        </button>
      </form>
      </div>
      <div className="signup-divider"></div>
      <div className="signup-right">
        <img src={ills} alt="Background Illustration" className="background-image" />
      </div>
    </div>
  );
};

export default Signup;